import { render } from "./NkPermDataSetting.vue?vue&type=template&id=89935ffa"
const script = {}

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__